import styled from 'styled-components';
import ContainerScroll from '../../../../../components/ContainerScroll';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  min-height: 300px;
`;

export const History = styled(ContainerScroll)`
  width: 100%;
  padding-top: 10px;
`;

export const Dados = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 20px;
`;

export const ItemDados = styled.div`
  opacity: 0.8;
  padding: 2px;
`;

export const ItemTimeLine = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
